<div class="scanner-main" data-testid="scanner-root">
  <div class="scanner-lhs" [class.mobile]="(screenSize$ | async)?.isMobile">
    <div class="scanner-lhs-header">
      <div class="scanner-lhs-title">
        {{ auth.getScoreName().name + ' Ranking' }}
        <h5 class="entities__number">Number of Entities: {{ items }}</h5>
      </div>
      <app-report-box
        class="scanner-lhs-actions"
        cardClass="report-card--scanner"
        mode="entity"
        [entity]="{
          type: 'portfolio',
          alpha_id: portfolioApi.activePortfolio?.uid,
          name: portfolioApi.activePortfolio?.name,
        }"
        [folio]="portfolioApi.activePortfolio"
        [customScore]="auth.scorelabSettings.defaultScore"
        buttonLabel="Report"
      ></app-report-box>
    </div>

    <div class="scanner-lhs-content">
      <app-scanner-items
        (itemsCountToParent)="handleItems($event)"
      ></app-scanner-items>
    </div>
  </div>

  <div
    class="scanner-rhs"
    *appShowOn="{ desktop: true, tablet: true, largeDesktop: true }"
  >
    <div class="scanner-insights">
      <app-scanner-insights></app-scanner-insights>
    </div>
    <div class="scanner-news">
      <app-news-newsfeed></app-news-newsfeed>
    </div>
  </div>
</div>
